import themes from 'developer-docs-shared-components/config/themes';
import { generateUrlWithVersionFromBaseUrl } from 'developer-docs-shared-components/config/versionInfo';
import RelatedDocs from 'developer-docs-shared-components/components/RelatedDocs';
import { apiReferenceLabels } from 'developer-docs-shared-components/config/navData/translations/labels';
import { useLocation } from 'react-router-dom';
import { API_GUIDES_PREFIX, REFERENCE_PREFIX } from '../utils/urls';
import { isApiReferenceLabel } from 'developer-docs-shared-components/config/navData/types';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

/**
 * The 'Related Apis' section shown at the top of a Guide Page.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const RelatedApiLink = () => {
  var _apiReferenceLabels$p;
  const location = useLocation();
  const theme = useContext(ThemeContext);
  if (theme && theme.themeName === themes.PORTAL_AUTHED.themeName) {
    return null;
  }
  const currentGuideKey = location.pathname.replace(`/${API_GUIDES_PREFIX}`, '');

  // get the last part of the path
  const pageLabel = currentGuideKey.split('/').pop();
  const title = pageLabel && isApiReferenceLabel(pageLabel) && ((_apiReferenceLabels$p = apiReferenceLabels[pageLabel]) === null || _apiReferenceLabels$p === void 0 ? void 0 : _apiReferenceLabels$p.call(apiReferenceLabels));
  if (!title) {
    return null;
  }
  const apiGuideRoute = `/${REFERENCE_PREFIX}${generateUrlWithVersionFromBaseUrl(currentGuideKey)}`;
  return /*#__PURE__*/_jsx(RelatedDocs, {
    href: apiGuideRoute,
    title: title,
    relatedDocType: "api"
  });
};
export default RelatedApiLink;